import React, { useState, useEffect, useContext, useMemo, useCallback } from "react";
// 4. Contrôles de pagination
export const PaginationControls = React.memo(({ 
  currentPage, 
  totalPages, 
  individualsPerPage, 
  totalIndividuals,
  onPageChange, 
  onLoadMore 
}) => {
  const canLoadMore = currentPage * individualsPerPage < totalIndividuals;

  const pageNumbers = useMemo(() => {
    const maxVisible = 5;
    let startPage, endPage;
    
    if (totalPages <= maxVisible) {
      startPage = 1;
      endPage = totalPages;
    } else if (currentPage <= 3) {
      startPage = 1;
      endPage = maxVisible;
    } else if (currentPage >= totalPages - 2) {
      startPage = totalPages - maxVisible + 1;
      endPage = totalPages;
    } else {
      startPage = currentPage - 2;
      endPage = currentPage + 2;
    }
    
    return Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i);
  }, [currentPage, totalPages]);

  return (
    <div className="flex justify-between items-center mt-4 px-3">
      <div>
        {canLoadMore && (
          <button
            onClick={onLoadMore}
            className="px-4 py-2 bg-indigo-500 text-white rounded hover:bg-indigo-600"
          >
            Load More
          </button>
        )}
      </div>
      
      <div className="flex items-center space-x-2">
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={`px-3 py-1 rounded border ${
            currentPage === 1 
              ? 'bg-gray-100 text-slate-400 cursor-not-allowed' 
              : 'bg-white text-indigo-600 hover:bg-indigo-50'
          }`}
        >
          <i className="bi bi-chevron-left"></i>
        </button>
        
        {pageNumbers.map((pageNum) => (
          <button
            key={pageNum}
            onClick={() => onPageChange(pageNum)}
            className={`w-8 h-8 rounded ${
              currentPage === pageNum
                ? 'bg-indigo-500 text-white'
                : 'bg-white text-indigo-600 hover:bg-indigo-50'
            }`}
          >
            {pageNum}
          </button>
        ))}
        
        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={`px-3 py-1 rounded border ${
            currentPage === totalPages 
              ? 'bg-gray-100 text-slate-400 cursor-not-allowed' 
              : 'bg-white text-indigo-600 hover:bg-indigo-50'
          }`}
        >
          <i className="bi bi-chevron-right"></i>
        </button>
      </div>
    </div>
  );
});
